//Generated File 
export default class Language{
	static readonly Arabic = `Arabic`;
	static readonly English = `English`;
}
